var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddrowIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#00BA88",
    stroke: "#00BA88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10C16 9.44772 15.5523 9 15 9C14.4477 9 14 9.44772 14 10V12C14 13.1046 13.1046 14 12 14H10C9.44772 14 9 14.4477 9 15C9 15.5523 9.44771 16 10 16H12C13.1046 16 14 16.8954 14 18V20C14 20.5523 14.4477 21 15 21C15.5523 21 16 20.5523 16 20V18C16 16.8954 16.8954 16 18 16H20C20.5523 16 21 15.5523 21 15C21 14.4477 20.5523 14 20 14H18C16.8954 14 16 13.1046 16 12V10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddrowIcon);
export default __webpack_public_path__ + "static/media/addrow_icon.5fb5db0bbc34bf87be8639bfbb6a2eef.svg";
export { ForwardRef as ReactComponent };